// extracted by mini-css-extract-plugin
export var accordionBtn = "AccordionItem-module--accordionBtn--11150";
export var accordionContent = "AccordionItem-module--accordionContent--fd275";
export var accordionItem = "AccordionItem-module--accordionItem--18c56";
export var accordionOpen = "AccordionItem-module--accordionOpen--b6d11";
export var activeNumber = "AccordionItem-module--activeNumber--27341";
export var arrowActive = "AccordionItem-module--arrowActive--dcd7d";
export var arrowDown = "AccordionItem-module--arrowDown--260f9";
export var arrowRotated = "AccordionItem-module--arrowRotated--5e926";
export var experiencMobileCardContent = "AccordionItem-module--experiencMobileCardContent--5e804";
export var experienceMobileCard = "AccordionItem-module--experienceMobileCard--e5aac";
export var indicatorNumber = "AccordionItem-module--indicatorNumber--55e8d";
export var kickerMargin = "AccordionItem-module--kickerMargin--6b052";
export var mobileCardImage = "AccordionItem-module--mobileCardImage--92a3e";
export var separatorLine = "AccordionItem-module--separatorLine--e1395";
export var titleContainer = "AccordionItem-module--titleContainer--1ce4a";
export var titleMargin = "AccordionItem-module--titleMargin--bf27e";